module.exports = __webpack_public_path__ + "static/media/payroll-providers@2x.e2c9bc97.png";